import api from '~/api'
import get from 'lodash/get'
import dropdownSorting from '@lib/utils/dropdown-sorting'

const state = {
  supplier: {},
  suppliers: {},
}

const getters = {}

const mutations = {
  SET_SUPPLIER(state, payload) {
    state.supplier = payload
  },
  SET_SUPPLIERS(state, { items }) {
    const newSuppliers = items.reduce((acc, s) => {
      acc[s.id] = s

      return acc
    }, {})

    state.suppliers = newSuppliers
  },
}

const actions = {
  async getSupplier({ commit }, supplierId) {
    const response = await api.get(`/suppliers/${supplierId}`)
    const [error, success] = response

    if (!error) {
      commit('SET_SUPPLIER', success)
    }

    return response
  },

  async createSupplier({ dispatch, commit }, { form }) {
    const response = await api.post('/suppliers', form)
    const [error] = response

    if (!error) {
      await dispatch('getSuppliers')
    }

    return response
  },

  async toggleSupplierStatus({ dispatch, commit }, { supplierId }) {
    const response = await api.patch(`/suppliers/${supplierId}/toggle-active`)

    const [error, success] = response

    if (!error) {
      commit('SET_SUPPLIER', success)
      await dispatch('getSuppliers')
    }

    return response
  },

  async updateSupplier({ dispatch, commit }, { supplierId, form }) {
    const response = await api.patch(
      `/suppliers/${supplierId}`,
      form
    )
    const [error, success] = response

    if (!error) {
      commit('SET_SUPPLIER', success)
      await dispatch('getSuppliers')
    }

    return response
  },

  async deleteSupplier({ dispatch, commit }, supplierId) {
    const response = await api.delete(`/suppliers/${supplierId}`)
    const [error] = response

    if (!error) {
      await dispatch('getSuppliers')
    }

    return response
  },

  async getSuppliers({ commit }) {
    const response = await api.post(
      '/search/suppliers/_search?from=0&size=500'
    )
    const [error, result] = response
    const suppliers = get(result, 'hits.hits', []).map(item => item._source)

    if (!error) {
      commit('SET_SUPPLIERS', { items: suppliers })
    }

    return [error, suppliers]
  },

  async searchSuppliersByName(_, string) {
    const [error, result] = await api.post(
      '/search/suppliers/_search?from=0&size=10',
      {
        query: {
          wildcard: { 'name': `*${String(string)}*` },
        },
      }
    )

    if (error) {
      console.error(error)

      return []
    }

    const suppliers = result.hits.hits.map(i => ({
      label: i._source.name,
      value: i._id,
    }))

    return dropdownSorting(suppliers, 'label')
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
